import React from "react";

const CustomLegend = ({ payload, COLORS, total }) => {
    return (
        <div className="flex flex-col gap-y-2 text-xs">
            {payload.map((entry, index) => (
                <div key={index} className="flex items-center justify-between w-45">

                    <div className="flex items-center">
                        <svg width="12" height="12">
                            <circle
                                cx="6"
                                cy="6"
                                r="5"
                                fill={COLORS[index]}
                            />
                        </svg>

                        <span className="text-black">{entry.value}</span>
                    </div>

                    <span className="text-gray-700 ml-5">
                        {((entry.payload.value / total) * 100).toFixed(1)}%
                    </span>

                </div>
            ))}
        </div>
    );
};

export default CustomLegend;